import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const assetsSearchRoute: InvariantJiraRoute = {
	name: 'assets-search-results',
	path: '/jira/assets/search',
	exact: true,
};
